import React, { useEffect, useState } from "react";
import Paper from "@material-ui/core/Paper";
import { lighten, makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import TableCell from "@material-ui/core/TableCell";
import EditNumberStatusTable from "./EditNumberStatusTable";
import { Alert } from "reactstrap";
import Select from "react-select";
import SearchIcon from "@material-ui/icons/Search";
import Typography from "@material-ui/core/Typography";
import Toolbar from "@material-ui/core/Toolbar";
import CircularProgress from "@material-ui/core/CircularProgress";
import { fetchWithToken } from "../../../../apiUtils";

const EnhancedTableToolbar = (props) => {
  const { classes } = props;
  return (
    <Toolbar>
      <Typography
        className={classes.title}
        variant="h6"
        id="tableTitle"
        component="div"
      >
        Edit Number Status
      </Typography>
    </Toolbar>
  );
};

const EditNumberStatusDropdown = (props) => {
  const { data, setNewRangeRequired, classes } = props;

  const [selectedPoolValue, setSelectedPoolValue] = useState(null);
  const [selectedSiteValue, setSelectedSiteValue] = useState(null);
  const [phoneNumberValue, setPhoneNumberValue] = useState(null);

  const [rangeArray, setRangeArray] = useState([]);
  const [phoneNumbers, setPhoneNumbers] = useState([]);

  const [selectedNumbers, setSelectedNumbers] = useState([]);

  const [searchDetails, setSearchDetails] = useState({
    display: false,
    pool: null,
    site: null,
    phoneNumber: null,
  });

  const [rangeLoading, setRangeLoading] = useState();

  const poolChangeHandler = (e) => {
    clearSearch();
    setPhoneNumberValue("");
    setSelectedPoolValue(e);
    setRangeArray([]); // needed to close old selected num edit table
    var pool = data.pools.filter((p) => p.id == e.value)[0];
    var site = data.sites.filter((s) => s.id == pool.siteId)[0];
    setSelectedSiteValue({
      value: site.id,
      label: `${site.id} - ${site.name}`,
    });
    setSearchDetails((prev) => ({
      ...prev,
      display: true,
      pool: e.label,
      site: `${site.id} - ${site.name}`,
    }));
    var rangeArray = data.ranges.filter((r) => r.siteId == site.id);
    setRangeArray(rangeArray);
    setRangeLoading(false);
  };

  const siteChangeHandler = (e) => {
    clearSearch();
    setPhoneNumberValue("");
    setSelectedSiteValue(e);
    setRangeArray([]); // needed to close old selected num edit table
    var site = data.sites.filter((s) => s.id == e.value)[0];
    setSelectedPoolValue(null);
    setSearchDetails((prev) => ({
      ...prev,
      display: true,
      site: `${site.id} - ${site.name}`,
    }));
    var rangeArray = data.ranges.filter((r) => r.siteId == site.id);
    setRangeArray(rangeArray);
    setRangeLoading(false);
  };

  const numberSearchHandler = (numToSearch) => {
    clearSearch();

    fetchWithToken(`api/PhoneNumber/${numToSearch}`)
      .then((response) => {
        if (response.ok) return response.json();
        else throw new Error("Single Number Not Found");
      })
      .then((responseJson) => {
        sendAlert(`Single Number Search Success`, "success");
        singleSearchHandler(responseJson);
      })
      .catch((e) => {
        fetchWithToken(`api/PhoneNumber/Partial/${numToSearch.toString()}`)
          .then((res) => {
            if (res.ok) {
              return res.json();
            } else throw new Error("Single Number Not Found");
          })
          .then((resJson) => {
            sendAlert(`Partial Number Search Success`, "success");
            partialSearchHandler(resJson);
          })
          .catch((e) => {
            console.log("catch e:", e);
            sendAlert(`No Single Or Partial Search Match`, "warning");
            setRangeLoading(false);
          });
      });
  };

  const singleSearchHandler = (number) => {
    number = { ...number, description: number.numberStatus.description };
    var tempRange = number.range;
    var range = data.ranges.filter((r) => r.id == tempRange.id);
    var tempPool = data.pools.filter((p) => p.id == tempRange.poolId)[0];
    var tempSite = data.sites.filter((s) => s.id == tempPool.siteId)[0];
    setRangeArray(range);
    setSelectedNumbers([number]);
    setPhoneNumbers([number]);

    setSearchDetails({
      display: true,
      site: tempSite.name,
      pool: tempPool.name,
      startNum: number.did,
      endNum: number.did,
    });

    setRangeLoading(false);
  };

  const partialSearchHandler = (numbers) => {
    var arrayRangeIds = [];
    var arrayOfRanges = [];
    numbers.map((n) => arrayRangeIds.push(n.rangeId));
    arrayRangeIds = [...new Set(arrayRangeIds)];
    arrayRangeIds.map((r) =>
      arrayOfRanges.push(data.ranges.filter((range) => range.id == r)[0])
    );
    setRangeArray(arrayOfRanges);
    setPhoneNumbers(numbers);
    setRangeLoading(false);
  };

  useEffect(() => {
    if (rangeArray.length > 0) {
      let updatedArray = [];
      rangeArray.map((rA) => {
        updatedArray.push(data.ranges.filter((r) => r.id == rA.id)[0]);
      });
      setRangeArray(updatedArray);
    }
  }, [data.ranges]);

  const clearSearch = () => {
    setRangeArray([]);
    setSearchDetails({
      display: false,
      pool: null,
      site: null,
      phoneNumber: null,
    });
    setSelectedPoolValue(null);
    setSelectedSiteValue(null);
    setRangeLoading(true);
    setPhoneNumbers([]);
    setSelectedNumbers([]);
  };

  const getPools = () => {
    return data.pools.map((pool) => {
      return { value: pool.id, label: `${pool.name}` };
    });
  };

  const getSites = () => {
    return data.sites.map((site) => {
      return { value: site.id, label: `${site.id} - ${site.name}` };
    });
  };

  const [alertMessage, setAlertMessage] = useState({
    message: "",
    active: false,
  });

  const sendAlert = (message, varient) => {
    setAlertMessage({
      message: message,
      varient: varient,
      active: true,
    });

    const timer = setTimeout(() => {
      setAlertMessage({
        message: "",
        varient: "",
        active: false,
      });
    }, 8500);
  };

  const setPNTest = (val) => {
    setPhoneNumberValue(val);
  };

  return (
    <>
      <div className={classes.table}>
        <Paper>
          {alertMessage.active && (
            <Alert color={alertMessage.varient}>{alertMessage.message}</Alert>
          )}

          <EnhancedTableToolbar classes={classes} />

          <TableCell style={{ width: "600px" }}>
            Pool
            <Select
              placeholder="Select Pool"
              options={getPools()}
              value={selectedPoolValue}
              onChange={poolChangeHandler}
              menuPortalTarget={document.querySelector("body")}
            />
          </TableCell>
          <TableCell style={{ width: "600px" }}>
            Site
            <Select
              placeholder="Select Site"
              options={getSites()}
              value={selectedSiteValue}
              onChange={siteChangeHandler}
              menuPortalTarget={document.querySelector("body")}
            />
          </TableCell>
          <TableCell>
            Number
            <div class="input-group mb-3">
              <input
                type="text"
                class="form-control"
                name="numberInput"
                id="numberInput"
                placeholder="Search #"
                value={phoneNumberValue}
                onChange={(e) => setPNTest(e.target.value)}
              />
              <div class="input-group-append">
                <Button
                  variant="contained"
                  size="small"
                  color="primary"
                  onClick={() =>
                    numberSearchHandler(
                      document.getElementById("numberInput").value
                    )
                  }
                >
                  <SearchIcon />
                </Button>
              </div>
            </div>
          </TableCell>
        </Paper>
      </div>
      {!rangeLoading ? (
        <div className={classes.table}>
          <EditNumberStatusTable
            classes={classes}
            sites={data.sites}
            ranges={rangeArray}
            statuses={data.statuses}
            phoneNumbers={phoneNumbers}
            setPhoneNumberValue={setPhoneNumberValue}
            setPhoneNumbers={setPhoneNumbers}
            selectedNumbers={selectedNumbers}
            setSelectedNumbers={setSelectedNumbers}
            setSearchDetails={setSearchDetails}
            searchDetails={searchDetails}
            setNewRangeRequired={setNewRangeRequired}
          />
        </div>
      ) : (
        <CircularProgress className={classes.loading} />
      )}
    </>
  );
};

export default EditNumberStatusDropdown;
